<template>
  <div
    id="modal-benefit-setting"
    title="新增簽到任務"
  >
    <div class="text-center mt-3 mb-3 loading-spinner" v-if="isLoading">
      <b-spinner variant="secondary" small />
    </div>
    <div class="mt-3 mb-3">
      <!-- 任務名稱 Start -->
      <b-form-group
        label-cols="12"
        label-cols-lg="2"
        label-size="sm"
        label="任務名稱"
      >
      <b-form-input
        type="text"
        :state="v$.form.name.$error ? false: null"
        v-model="form.name"
      ></b-form-input>
      <b-form-invalid-feedback :state="!v$.form.name.$error">
        此欄位為必填
      </b-form-invalid-feedback>
      </b-form-group>
      <!-- 任務名稱 End -->
      <!-- 使用期間 Start -->
      <b-form-group
        label-cols="12"
        label-cols-lg="2"
        label-size="sm"
        label="使用期間"
      >
        <div class="d-flex align-items-center mb-2">
          <b-form-radio v-model="form.period_type" value="by_checkin_campaign">
            與簽到活動相同
          </b-form-radio>
        </div>
        <div class="d-flex align-items-center mb-2">
          <b-form-radio v-model="form.period_type" value="custom" class="mr-2">
            自訂期限
          </b-form-radio>
          <div class="d-flex align-items-center">
            <datepicker
                placeholder="選擇日期"
                v-model="form.start_at"
                bootstrap-styling
                :language="zh"
                format="yyyy-MM-dd"
                :disabled="form.period_type !== 'custom'"
            ></datepicker>
            <span class="mx-2">~</span>
            <datepicker
                placeholder="選擇日期"
                v-model="form.end_at"
                bootstrap-styling
                :language="zh"
                format="yyyy-MM-dd"
                :disabled="form.period_type !== 'custom'"
            ></datepicker>
          </div>
        </div>
      </b-form-group>
      <!-- 使用期間 End -->

      <!-- 達成條件 Start -->
      <b-form-group
        label-cols="12"
        label-cols-lg="2"
        label-size="sm"
        label="達成條件"
      >
        <div class="d-flex align-items-center mb-2">

          <b-form-radio v-model="form.conditions.type" value="streak_type">
            連續簽到
          </b-form-radio>
          <b-form-input
            v-model="form.conditions.streak_days"
            class="mx-2"
            style="width: 100px"
          ></b-form-input>
          <span>天</span>
        </div>
        <b-form-invalid-feedback :state="!v$.form.conditions.streak_days.$error">
          此欄位為必填
        </b-form-invalid-feedback>

        <div class="d-flex align-items-center mb-2">
          <b-form-radio v-model="form.conditions.type" value="total_type">
            累積簽到
          </b-form-radio>
          <b-form-input
            v-model="form.conditions.total_days"
            class="mx-2"
            style="width: 100px"
          ></b-form-input>
          <span>天</span>
        </div>
        <b-form-invalid-feedback :state="!v$.form.conditions.total_days.$error">
          此欄位為必填
        </b-form-invalid-feedback>

        <div class="d-flex align-items-center mb-2">
          <b-form-radio v-model="form.conditions.type" value="period_type">
            於
          </b-form-radio>
          <div class="d-flex align-items-center mx-2">
            <div class="row">
              <div class="col-12 col-xl-6">
                <datepicker
                  placeholder="選擇日期"
                  v-model="period_start_at.date"
                  bootstrap-styling
                  format="yyyy-MM-dd"
                  :language="zh"
                  :state="v$.period_start_at.date.$error ? false : null"
                ></datepicker>
                <div class="feedback-placeholder">
                  <b-form-invalid-feedback  :state="!v$.period_start_at.date.$error">
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>
              </div>
              <div class="col-12 col-xl-6">
                <vue-timepicker
                  placeholder="選擇時間"
                  format="HH:mm"
                  v-model="period_start_at.time"
                  :input-class="['form-control']"
                  :state="v$.period_start_at.time.HH.$error || v$.period_start_at.time.mm.$error 
                    ? false : null"
                ></vue-timepicker>
                <div class="feedback-placeholder">
                  <b-form-invalid-feedback :state="!v$.period_start_at.time.HH.$error || !v$.period_start_at.time.mm.$error">
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
            <span class="mx-2">~</span>
            <div class="row">
              <div class="col-12 col-xl-6">
                <datepicker
                  placeholder="選擇日期"
                  v-model="period_end_at.date"
                  bootstrap-styling
                  format="yyyy-MM-dd"
                  :language="zh"
                  :state="v$.period_end_at.date.$error ? false : null"
                ></datepicker>
                <div class="feedback-placeholder">
                  <b-form-invalid-feedback  :state="!v$.period_end_at.date.$error">
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>
                <b-form-invalid-feedback :state="!v$.period_start_at.date.beforeEndAt.$invalid">
                  結束時間必須大於起始時間
                </b-form-invalid-feedback>
              </div>

              <div class="col-12 col-xl-6">
                <vue-timepicker
                  placeholder="選擇時間"
                  format="HH:mm"
                  v-model="period_end_at.time"
                  :input-class="['form-control']"
                ></vue-timepicker>
                <div class="feedback-placeholder">
                  <b-form-invalid-feedback :state="!v$.period_end_at.time.HH.$error || !v$.period_end_at.time.mm.$error">
                    此欄位為必填
                  </b-form-invalid-feedback>
                </div>
              </div>
            </div>
          </div>
          <span>簽到</span>
        </div>
      </b-form-group>
      <!-- 達成條件 End -->
    </div>

    <template>
      <div class="w-100">
        <div class="d-flex justify-content-center">
          <b-button
            variant="danger"
            size="sm"
            class="mr-2 ml-5"
            @click="closeModal"
          >
            取消
          </b-button>
          <b-button
            variant="success"
            size="sm"
            @click="submitMissionSetting"
          >
             儲存
          </b-button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import {required, requiredIf} from "@vuelidate/validators";
import {displayText} from "@/utils/dashboardUtils";
import {cloneDeep} from "lodash";
import moment from "moment/moment";
import useVuelidate from "@vuelidate/core";
import deepGet from "@/utils/deepGet";
import { zh } from "vuejs-datepicker/dist/locale";
import { format, isBefore, set } from "date-fns";
import VueTimepicker from "vue2-timepicker";
import checkinMissionApi from "@/apis/checkinMission";

export default {
  components: {
    Datepicker, VueTimepicker
  },
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return {
      period_start_at: {
        date: {
          required: requiredIf(() => this.form.conditions.type === 'period_type'),
          beforeEndAt: () => {
            if (!this.period_start_at.date || !this.period_end_at.date) {
              return true;
            }

            const startDate = set(new Date(this.period_start_at.date), {
              hours: this.period_start_at.time.HH,
              minutes: this.period_start_at.time.mm,
            });

            const endDate = set(new Date(this.period_end_at.date), {
              hours: this.period_end_at.time.HH,
              minutes: this.period_end_at.time.mm,
            });

            return isBefore(startDate, endDate);
          },
        },
        time: {
          HH: { required: requiredIf(() => this.form.conditions.type === 'period_type') },
          mm: { required: requiredIf(() => this.form.conditions.type === 'period_type') },
        },
      },
      period_end_at: {
        date: { required: requiredIf(() => this.form.conditions.type === 'period_type') },
        time: {
          HH: { required: requiredIf(() => this.form.conditions.type === 'period_type') },
          mm: { required: requiredIf(() => this.form.conditions.type === 'period_type') },
        },
      },
      form: {
        name: { required },
        period_type: { required },
        conditions: {
          type: { required },
          streak_days: { 
            required: requiredIf(() => this.form.conditions.type === 'streak_type') 
          },
          total_days: {
            required: requiredIf(() => this.form.conditions.type === 'total_type')
          },
          period_start_at: {
            required: requiredIf(() => this.form.conditions.type === 'period_type')
          },
          period_end_at: {
            required: requiredIf(() => this.form.conditions.type === 'period_type')
          }
        },
      }
    };
  },
  props: {
    checkinCampaignId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      zh,
      missionId: null,
      isLoading: false,
      isSubmitting: false,
      isEditting: false,
      form: {
        checkin_campaign_id: '',
        name: null,
        period_type: "by_checkin_campaign",
        start_at: null,
        end_at: null,
        conditions: {
          type: "streak_type",
          streak_days: null,
          total_days: null,
          period_start_at: null,
          period_end_at: null,
        },
      },
      tempMission: {},
      localMission: {},
      period_start_at: {
          date: new Date(),
          time: {
            HH: "00",
            mm: "00",
          },
        },
      period_end_at: {
        date: null,
        time: {
          HH: "23",
          mm: "59",
        },
      },
    };
  },
  methods: {
    displayText,
    deepGet,
    format,
    initialize(selectedMission) {
      this.tempMission = selectedMission; // 保存取消時的還原基準
      this.form = cloneDeep(selectedMission) // 初始化本地副本

      if (selectedMission.id) {
        this.isEditting = true;
        this.missionId = selectedMission.id;
      }
      this.v$.$reset(); // 重置驗證狀態，避免初始化時觸發驗證
    },

    async submitMissionSetting() {
      this.form.checkin_campaign_id = this.checkinCampaignId;
      if (this.period_start_at.date && this.period_start_at.time.HH && this.period_start_at.time.mm) {
        this.form.conditions.period_start_at = format(
          set(new Date(this.period_start_at.date), {
            hours: Number(this.period_start_at.time.HH),
            minutes: Number(this.period_start_at.time.mm),
            seconds: 0,
          }),
          "yyyy-MM-dd HH:mm:ss"
        );
      }

      if (this.period_end_at.date && this.period_end_at.time.HH && this.period_end_at.time.mm) {
        this.form.conditions.period_end_at = format(
          set(new Date(this.period_end_at.date), {
            hours: Number(this.period_end_at.time.HH),
            minutes: Number(this.period_end_at.time.mm),
            seconds: 0,
          }),
          "yyyy-MM-dd HH:mm:ss"
        );
      }
      const result = await this.v$.$validate();
      if (!result) {
        console.log(this.v$.$errors);
        return false;
      }

      if (this.isEditting) {
        // 編輯模式
        await checkinMissionApi.updateCheckinMission(this.missionId, this.form);
      } else {
        // 新增模式
        await checkinMissionApi.createCheckinMission(this.form);
      }
      this.closeModal();
    },

    closeModal() {
      this.$emit("close");
      if (Object.keys(this.tempMission) > 0) {
        this.localMission = { ...this.tempMission }; // 還原資料
      }
      this.isEditting = false;
    },

    handleEdit(bvModalEvt) {
      bvModalEvt.preventDefault();

      if (this.selectedOption === 0) { // 選擇0,要選擇開始結束日期
        if (this.dateBetween.start_at == null || this.dateBetween.end_at == null) {
          this.$swal.fire({
            title: "開始日期與結束日期不可為空",
            type: "error",
          });
          return;
        }

        // 確保結束日期不小於開始日期
        if (new Date(this.dateBetween.end_at) < new Date(this.dateBetween.start_at)) {
          this.$swal.fire({
            title: "結束日期不可早於開始日期",
            type: "error",
          });
          return;
        }

        this.coupon.redeem_code_start_at = this.dateBetween.start_at;
        this.coupon.redeem_code_end_at = this.dateBetween.end_at;

      } else if (this.selectedOption === 1) { // 選擇1,要輸入區間
        if (this.start_days_after_take < 0) {
          this.$swal.fire({
            title: "領取後幾日可以使用不可小於0",
            type: "error",
          });
          return;
        } else if(this.end_days_after_take < 0) {
          this.$swal.fire({
            title: "領取後幾日內有效不可小於0",
            type: "error",
          });
          return;
        }

        this.coupon.start_days_after_take = this.start_days_after_take;
        this.coupon.end_days_after_take = this.end_days_after_take;
      }

      if(!this.coupon.quantity) {
        this.$swal.fire({
          title: "請輸入數量",
          type: "error",
        });
        return;
      } else if(isNaN(this.coupon.quantity)) {
        this.$swal.fire({
          title: "請輸入數字",
          type: "error",
        });
        this.coupon.quantity = this.tempCouponQuantity
        return;
      }

      if (Array.isArray(this.localMission.redeem_code_bundles) && this.localMission.redeem_code_bundles.length > 0) {
        const matchingRedeemCode = this.localMission.redeem_code_bundles.find(
          (bundle) => bundle.hashid === this.coupon.id
        );

        // 最終輸出的coupon會夾帶哪些欄位
        if (matchingRedeemCode) {
          matchingRedeemCode.quantity = this.coupon.quantity;
          matchingRedeemCode.dateline_type = this.selectedOption;

          if (this.selectedOption === 0) {
            matchingRedeemCode.redeem_code_start_at = this.dateBetween.start_at;
            matchingRedeemCode.redeem_code_end_at = this.dateBetween.end_at;
          } else {
            delete matchingRedeemCode.redeem_code_start_at;
            delete matchingRedeemCode.redeem_code_end_at;
          }
          if (this.selectedOption === 1) {
            matchingRedeemCode.start_days_after_take = this.start_days_after_take;
            matchingRedeemCode.end_days_after_take   = this.end_days_after_take;
          } else {
            delete matchingRedeemCode.start_days_after_take;
            delete matchingRedeemCode.end_days_after_take;
          }
        }
      }

      this.coupon.dateline_type = this.selectedOption;

      this.$nextTick(() => {
        this.$bvModal.hide("modal-edit-quantity");
      });
    },
    closeEditQuantity() {
      this.coupon.quantity = this.tempCouponQuantity
      this.$bvModal.hide("modal-edit-quantity");
    },
    handleDateChange(between) {
      const startAt = (between.start_at) ? moment(between.start_at).format("YYYY-MM-DD 00:00:00") : null;
      const endAt = (between.end_at) ? moment(between.end_at).format("YYYY-MM-DD 23:59:59") : null;

      this.dateBetween.start_at = startAt;
      this.dateBetween.end_at = endAt;
    },
  }
};
</script>

<style lang="scss">
  .table-responsive {
    min-height: auto;
  }
</style>
